import { useMutation, useQuery } from 'react-query'
import API, { useGetInfinite } from '.'

const ENDPOINT = '/api/dealerships'
const QUERY_KEY = 'dealerships'

export const useGetDealerships = (params = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'list', params],
    async () => (await API.get(`${ENDPOINT}?${new URLSearchParams(params).toString()}`)).data,
    config
  )

export const useGetDealership = (id, config = {}) =>
  useQuery([QUERY_KEY, 'detail', id], async () => (await API.get(`${ENDPOINT}/${id}`)).data, config)

export const useCreateDealership = (config = {}) =>
  useMutation((data) => API.post(ENDPOINT, data), config)

export const useEditDealership = (config = {}) =>
  useMutation((data) => API.patch(ENDPOINT, data), config)

export const useGetDealershipsInfinite = (params = {}, config = {}) =>
  useGetInfinite({ key: QUERY_KEY, endpoint: ENDPOINT, params, config })
